import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../api/api.service';

@Component({
  selector: 'app-contacts-content',
  templateUrl: './contacts-content.component.html',
  styleUrls: ['./contacts-content.component.css']
})
export class ContactsContentComponent implements OnInit {

  errorInput = false
  loading = false
  sent = false

  constructor(
    private api: ApiService
  ) { }

  ngOnInit() {
    window.scroll(0,0)
  }

  redirectContacts() {
    window.open("/contacts", "_blank");
  }

  inviaMessaggio(name: HTMLInputElement, mail, tel, message) {
    const nome = name.value;
    const email = mail.value;
    const telefono = tel.value;
    const messaggio = btoa(message.value);

    if(nome.length == 0 || email.length == 0 || messaggio.length == 0) {
      this.errorInput = true;
      return;
    } else
      this.errorInput = false
    this.loading = true;
    this.api.sendMessageContacts(nome, email, telefono, messaggio).subscribe(() => {
      this.loading = false;
      this.sent = true;
    })

  }

}
